import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "flex items-center space-x-2" };
import { FolderIcon } from '@gohighlevel/ghl-icons/24/outline';
import { UICard, UITextSmMedium, UITooltip } from '@gohighlevel/ghl-ui';
import { truncate } from 'lodash';
export default /*#__PURE__*/ _defineComponent({
    __name: 'FolderComponent',
    props: {
        folder: {},
        activeItem: {}
    },
    setup(__props) {
        return (_ctx, _cache) => {
            var _a;
            return (_openBlock(), _createBlock(_unref(UICard), {
                class: _normalizeClass([
                    _ctx.folder._id === _ctx.activeItem ? 'selectFolder' : '',
                    'cursor-pointer',
                    'folder-card-wrapper',
                    'bg-red-800',
                    'shadow-xs',
                ]),
                id: (_a = _ctx.folder) === null || _a === void 0 ? void 0 : _a._id
            }, {
                default: _withCtx(() => {
                    var _a;
                    return [
                        _createElementVNode("div", _hoisted_1, [
                            _createElementVNode("div", null, [
                                _createVNode(_unref(FolderIcon), {
                                    id: (_a = _ctx.folder) === null || _a === void 0 ? void 0 : _a._id,
                                    class: "w-5 h-5"
                                }, null, 8, ["id"])
                            ]),
                            _createVNode(_unref(UITextSmMedium), { class: "truncate text-black" }, {
                                default: _withCtx(() => [
                                    _createVNode(_unref(UITooltip), null, {
                                        trigger: _withCtx(() => {
                                            var _a;
                                            return [
                                                _createTextVNode(_toDisplayString(_unref(truncate)((_a = _ctx.folder) === null || _a === void 0 ? void 0 : _a.name)), 1)
                                            ];
                                        }),
                                        default: _withCtx(() => {
                                            var _a;
                                            return [
                                                _createTextVNode(_toDisplayString((_a = _ctx.folder) === null || _a === void 0 ? void 0 : _a.name), 1)
                                            ];
                                        }),
                                        _: 1
                                    })
                                ]),
                                _: 1
                            })
                        ])
                    ];
                }),
                _: 1
            }, 8, ["class", "id"]));
        };
    }
});
